import { api } from '../../../shared/services/api'

import type {
  CreatePublisherInput,
  ManagedUser,
  UpdatePublisherInput,
} from '../types/publisher.types'

export const publisherApi = {
  list: () => api.get<ManagedUser[]>('/users'),
  create: (data: CreatePublisherInput) => api.post<ManagedUser>('/users', data),
  update: (id: number, data: UpdatePublisherInput) => api.put<ManagedUser>(`/users/${id}`, data),
  remove: (id: number) => api.delete<ManagedUser>(`/users/${id}`),
}
